import { createAsyncTypes } from '../utils'

export const postInversion = createAsyncTypes('POST_INVERSION')
